export default "__VITE_ASSET__gLnWhmdC__"